export default __webpack_public_path__ + "static/media/hitWall.aafec861.wav";